module.exports = __webpack_public_path__ + "img/logout.62161f85.svg";